import { render, staticRenderFns } from "./ChartStatusProdutos.vue?vue&type=template&id=6064112b"
import script from "./ChartStatusProdutos.vue?vue&type=script&lang=js"
export * from "./ChartStatusProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports